import { SessionStorageService } from './../storage/sessionStorage.service';
import { LocalService } from './../storage/localService';
import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders} from '@angular/common/http';
import { AccesoService } from '../acceso/acceso.service';
import { environment } from '../../../environments/environment';
import { FiltrosCPE } from 'app/models/FiltrosCPE';
import { filter, pluck } from "rxjs/operators";
import { Observable } from "rxjs";
@Injectable({
  providedIn: 'root'
})
export class FacturacionCPEService {

  readonly urlBase =  environment.rutaBase;
  //readonly urlBase =  "http://localhost:2528/api-facturacion";

  header : HttpHeaders;
  datos:any;
  TipoCambio:any;
  Productos:any;
  DataBuscar:any;
  dataFactura:any;
  detalleFactura:any;
  message: Observable<any>;
  idEmpresa_Factor : any;
  
  constructor(private http: HttpClient,
              private accesoService :AccesoService,
              private sessionStorageService: SessionStorageService,
              private localService : LocalService) {

    this.header = this.accesoService.desencriptarTOKEN();

    this.datoStorage()
  }

  datoStorage(){
    this.message = this.sessionStorageService.storageChange$.pipe(
      filter(({ storageArea }) => storageArea === "sessionStorage"),
      filter(({ key }) => key === '1cefada07eb9',),
      pluck("value")
    );
   this.message.subscribe(val => this.idEmpresa_Factor = val - this.localService.getJsonValue('numeroRandom'))
   if (this.idEmpresa_Factor == undefined) {
    this.idEmpresa_Factor = Number(sessionStorage.getItem('1cefada07eb9')) - this.localService.getJsonValue('numeroRandom')
   } 
  }
  
  facturarConfirming(data:any){
    let headers = this.header;
    return  this.http.post(`${this.urlBase}/Facturacion/FacturarConfirming?idEmpresa_Factor=${this.idEmpresa_Factor}`,data,{headers});
  }

  FiltrosListadoCPE(Filtro:FiltrosCPE,FechaIni,FechaFin){
    let headers = this.header;
    return  this.http.get(`${this.urlBase}/Facturacion?idEmpresa_Factor=${this.idEmpresa_Factor}&Tipo=${Filtro.Tipo_Comprobante_CPE}&Ruc=${Filtro.ClienteRuc}&Serie=${Filtro.Serie}&Numero=${Filtro.NumeroFact}&FechaIni=${FechaIni}&FechaFin=${FechaFin}&Estado=${Filtro.Estado}&Moneda=${Filtro.Moneda}`,{headers});
  }

  FiltrosListadoFacturaDetail(Filtro:FiltrosCPE,date:any){
     if (date == null || date == '') { date = '' }
    let headers = this.header;
    return  this.http.get(`${this.urlBase}/Facturacion/Detail?idEmpresa_Factor=${this.idEmpresa_Factor}&Tipo_Comprobante=${Filtro.Tipo_Comprobante_CPE}&Serie=${Filtro.Serie}&Numero=${Filtro.NumeroFact}&Fecha_Emision=${date}`,{headers});
  }
  GuardarCPEFacturaDeuda(data : any){
    let headers = this.header;
    return  this.http.post(`${this.urlBase}/Facturacion/FacturaDeuda?idEmpresa_Factor=${this.idEmpresa_Factor}`,data,{headers})
  }

  GuardarCPEFactura(data : any){
    let headers = this.header;
    return  this.http.post(`${this.urlBase}/Facturacion/Factura?idEmpresa_Factor=${this.idEmpresa_Factor}`,data,{headers})
  }

  GuardarCPENotaC(data : any){
    let headers = this.header;
    return  this.http.post(`${this.urlBase}/Facturacion/NotaCredito?idEmpresa_Factor=${this.idEmpresa_Factor}`,data,{headers})
  }

  GuardarCPENotaD(data : any){
    let headers = this.header;
    return  this.http.post(`${this.urlBase}/Facturacion/NotaDebito?idEmpresa_Factor=${this.idEmpresa_Factor}`,data,{headers})  
  }

  ObtenerNumeracion(Tipo_Documento){
    let headers = this.header;
    return  this.http.get(`${this.urlBase}/Facturacion/Correlativo?idEmpresa_Factor=${this.idEmpresa_Factor}&idLocal=1&Tipo_Documento=${Tipo_Documento}`,{headers});
  }

  eFactEnviar(id){
    let headers = this.header;
    return  this.http.post(`${this.urlBase}/Facturacion/Send/${id}?idEmpresa_Factor=${this.idEmpresa_Factor}`,[],{headers});  
  }

  //NUEVO
  ObtenerDocumentoPorId(id){
    let headers = this.header;
    return  this.http.get(`${this.urlBase}/Facturacion/${id}?idEmpresa_Factor=${this.idEmpresa_Factor}`,{headers});
  }

  UpdateCP(data){
    let headers = this.header;
    return  this.http.put(`${this.urlBase}/Facturacion?idEmpresa_Factor=${this.idEmpresa_Factor}`,data,{headers})
  }
}